import React from "react";
import { Sheet, SheetContent, SheetTitle } from "./ui/sheet";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import { ActionPlanTab } from "./ActionPlanTab";
import { DrawerHeader } from "./drawer/DrawerHeader";
import { AuditTab } from "./drawer/AuditTab";
import { MessagesTab } from "./drawer/MessagesTab";
import { SequenceTab } from "./drawer/SequenceTab";
import { PresenceTab } from "./drawer/PresenceTab";
import { QualifyTab } from "./drawer/QualifyTab";
import { useProspectActions } from "./drawer/useProspectActions";

export default function ProspectDrawer({ prospect, open, onOpenChange, onChanged, onEdit, onDeleted }) {
  const a = useProspectActions(prospect, { onChanged, onOpenChange, onDeleted });
  const { p, busy } = a;
  if (!p) return null;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full overflow-y-auto border-l border-border bg-card p-0 sm:max-w-xl" data-testid="prospect-drawer">
        <SheetTitle className="sr-only">{p.azienda} — dettaglio prospect</SheetTitle>
        <DrawerHeader p={p} analyzing={!!busy.analyze} onAnalyze={a.analyze} onStatus={a.changeStatus} onEdit={onEdit} onRemove={a.remove} />

        <Tabs defaultValue="audit" className="p-6">
          <TabsList className="grid w-full grid-cols-6">
            <TabsTrigger value="audit" data-testid="tab-audit">Audit</TabsTrigger>
            <TabsTrigger value="plan" data-testid="tab-plan">Piano</TabsTrigger>
            <TabsTrigger value="messages" data-testid="tab-messages">Messaggi</TabsTrigger>
            <TabsTrigger value="sequence" data-testid="tab-sequence">Sequenza</TabsTrigger>
            <TabsTrigger value="presence" data-testid="tab-presence">Presenza</TabsTrigger>
            <TabsTrigger value="qualify" data-testid="tab-qualify">Qualifica</TabsTrigger>
          </TabsList>

          <TabsContent value="audit" className="space-y-4 pt-5"><AuditTab p={p} /></TabsContent>
          <TabsContent value="plan" className="pt-4">
            <ActionPlanTab p={p} running={!!busy.engine} regen={!!busy.plan} onRunEngine={a.runEngine} onRegenPlan={a.regenPlan} />
          </TabsContent>
          <TabsContent value="messages" className="space-y-4 pt-4">
            <MessagesTab p={p} generating={!!busy.msg} onGenerate={a.generateMessages} />
          </TabsContent>
          <TabsContent value="sequence" className="space-y-4 pt-4">
            <SequenceTab p={p} onStart={a.startSequence} onCompleteStep={a.completeStep} onAddLog={a.addLog} />
          </TabsContent>
          <TabsContent value="presence" className="pt-4">
            <PresenceTab p={p} fetching={!!busy.ig} onFetchInstagram={a.fetchInstagram} />
          </TabsContent>
          <TabsContent value="qualify" className="space-y-4 pt-4"><QualifyTab p={p} onSave={a.saveQualification} /></TabsContent>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
}
